<template>
  <div class="main_wrap">
    <div class="toolbar_box">
      <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
    </div>
    <div class="item_type_box">
      <!-- 顶级分类 -->
      <div class="item_type_info">
        <div class="tit">
          <span>一级分类</span>
          <el-button type="primary" size="mini" @click="addProType(1)" v-if="isShowAdd">添加</el-button>
        </div>
        <ul>
          <li class="item_type" v-for="item in typeList" :key="item.id" @click="getProduct_TypeList2(item.id)"
            :class="activeId1 === item.id ? 'active_bg' : ''">
            <div class="item_type_l">
              <p class="active_icon" :class="item.isActive ? 'no_enabled' : 'enabled'"></p>
              <span>{{ item.name }} {{ item.id }}</span>
              <!-- <el-badge :value="item.IsHotShow ? 'hot' : ''">
                <span>{{item.TypeName}}</span>
              </el-badge> -->
            </div>
            <div class="item_type_r">
              <el-button type="text" v-if="isShowEdit" @click.stop="handleEdit(item, 1)">编辑</el-button>
              <el-button type="text" v-if="isShowDel" @click.stop="handleDel(item, 1)">删除</el-button>
              <i class="el-icon-arrow-down" :class="activeId1 === item.id ? 'rotate' : ''"></i>
            </div>
          </li>
        </ul>
      </div>
      <!-- 二级分类 -->
      <div class="item_type_info">
        <div class="tit">
          <span>二级分类</span>
          <el-button v-if="typeList[0] && isShowAdd" type="primary" size="mini" @click="addProType(2)"
            searchData>添加</el-button>
        </div>
        <ul>
          <li class="item_type" v-for="item in typeList2" :key="item.id" @click="getProduct_TypeList3(item.id)"
            :class="activeId2 === item.id ? 'active_bg' : ''">
            <div class="item_type_l">
              <p class="active_icon" :class="item.isActive ? 'no_enabled' : 'enabled'"></p>
              <span>{{ item.name }} {{ item.id }}</span>
              <!-- <el-badge :value="item.IsHotShow ? 'hot' : ''">
                <span>{{item.TypeName}}</span>
              </el-badge> -->
            </div>
            <div class="item_type_r">
              <el-button type="text" v-if="isShowEdit" @click.stop="handleEdit(item, 2)">编辑</el-button>
              <el-button type="text" v-if="isShowDel" @click.stop="handleDel(item, 2)">删除</el-button>
              <i class="el-icon-arrow-down" :class="activeId2 === item.id ? 'rotate' : ''"></i>
            </div>
          </li>
          <li class="no_type" v-if="!typeList2[0]">暂无数据</li>
        </ul>
      </div>
      <!-- 三级分类 -->
      <div class="item_type_info">
        <div class="tit">
          <span>三级分类</span>
          <el-button v-if="typeList2[0] && isShowAdd" type="primary" size="mini" @click="addProType(3)">添加</el-button>
        </div>
        <ul>
          <li class="item_type" v-for="item in typeList3" :key="item.id" @click="getProduct_TypeList4(item.id)"
            :class="activeId3 === item.id ? 'active_bg' : ''">
            <div class="item_type_l">
              <p class="active_icon" :class="item.isActive ? 'no_enabled' : 'enabled'"></p>
              <span>{{ item.name }} {{ item.id }}</span>
              <!-- <el-badge :value="item.IsHotShow ? 'hot' : ''">
                <span>{{item.TypeName}}</span>
              </el-badge> -->
            </div>
            <div class="item_type_r">
              <el-button type="text" v-if="isShowEdit" @click.stop="handleEdit(item, 3)">编辑</el-button>
              <el-button type="text" v-if="isShowDel" @click.stop="handleDel(item, 3)">删除</el-button>
              <!-- <i class="el-icon-arrow-down" :class="activeId3 === item.id?'rotate':''"></i> -->
            </div>
          </li>
          <li class="no_type" v-if="!typeList3[0]">暂无数据</li>
        </ul>
      </div>
      <!-- 四级分类 -->
      <!-- <div class="item_type_info">
        <div class="tit">
          <span>四级分类</span>
          <el-button
            v-if="typeList3[0] && isShowAdd"
            type="primary"
            size="mini"
            @click="addProType(4)"
          >添加</el-button>
        </div>
        <ul>
          <li class="item_type" v-for="item in typeList4" :key="item.id">
            <div class="item_type_l">
              <p class="active_icon" :class="item.isActive?'no_enabled':'enabled'"></p>
              <span>{{item.name}}</span>
              <el-badge :value="item.IsHotShow ? 'hot' : ''">
                <span>{{item.TypeName}}</span>
              </el-badge>
            </div>
            <div class="item_type_r">
              <el-button type="text" v-if="isShowEdit" @click.stop="handleEdit(item, 4)">编辑</el-button>
              <el-button type="text" v-if="isShowDel" @click.stop="handleDel(item, 4)">删除</el-button>
              <i class="el-icon-arrow-down"></i>
            </div>
          </li>
          <li class="no_type" v-if="!typeList4[0]">暂无数据</li>
        </ul>
      </div> -->
    </div>

    <!--新增界面-->
    <el-dialog :title="dialogTit" :visible.sync="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="100px">
        <el-form-item label="分类名称">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="addForm.isActive">
            <el-radio :label="item.value" v-for="item in labelList" :key="item.label">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" v-preventClick @click.native="addSubmit">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑-->
    <el-dialog v-if="editFormVisible" :title="dialogTit" :visible.sync="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="100px">
        <el-form-item label="分类名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="editForm.isActive">
            <el-radio :label="item.value" v-for="item in labelList" :key="item.label">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" v-preventClick @click.native="editSubmit">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  CategoryGetAll,
  CategoryGet,
  CategoryCreate,
  CategoryDelete,
  CategoryUpdate,
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
export default {
  components: { toolbar },
  data() {
    return {
      typeList: [],
      typeList2: [],
      typeList3: [],
      typeList4: [],

      activeId1: null,
      activeId2: null,
      activeId3: null,

      addFormVisible: false,
      editFormVisible: false,
      picFormVisible: false,
      paramFormVisible: false,

      labelList: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "禁用",
          value: false,
        },
      ],

      typeLevel: 1, // 品类等级
      addForm: {
        name: "",
        isActive: true,
        parentId: 0, //父ID
      },
      editForm: {
        name: "",
        isActive: true,
        parentId: 0, //父ID
      },
      dialogTit: "", //弹框标题
      //控制按钮
      isShowAdd: false,
      isShowEdit: false,
      isShowDel: false,

      buttonList_toolBar: [],
      buttonList_table: [],
    };
  },
  created() {
    this.getProduct_TypeList();
  },
  methods: {
    callFunction() {
      this[item.Func]();
    },
    //打开添加弹窗
    addProType(typeLevel) {
      let that = this;
      that.addFormVisible = true;
      switch (typeLevel) {
        case 1:
          that.dialogTit = "添加一级分类";
          that.typeLevel = typeLevel;
          that.addForm.parentId = 0
          break;
        case 2:
          that.dialogTit = "添加二级分类";
          that.typeLevel = typeLevel;
          that.addForm.parentId = that.activeId1;
          break;
        case 3:
          that.dialogTit = "添加三级分类";
          that.typeLevel = typeLevel;
          that.addForm.parentId = that.activeId2;
          break;
        case 4:
          that.dialogTit = "添加四级分类";
          that.typeLevel = typeLevel;
          that.addForm.parentId = that.activeId3;
          break;
      }
    },
    //提交添加
    addSubmit() {
      let that = this;
      let params = that.addForm;
      // console.log(that.addForm,'?????????')
      debugger
      CategoryCreate(params)
        .then((res) => {
          if (res.data.success) {
            // that.$message.error(res.data.error.message)
            that.addForm.name = "";
            // that.addForm.PropertyGroupId = 0;
            that.addFormVisible = false;
            switch (that.typeLevel) {
              case 1:
                that.getProduct_TypeList();
                break;
              case 2:
                that.getProduct_TypeList2(params.parentId);
                break;
              case 3:
                that.getProduct_TypeList3(params.parentId);
                break;
              case 4:
                that.getProduct_TypeList4(params.parentId);
                break;
            }
          } else {
            that.$message.error(res.data.error.message)
          }

        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //删除分类
    handleDel(item, typeLevel) {
      let that = this;
      that
        .$confirm("确认删除此分类吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let param = {
            id: item.id,
          };
          CategoryDelete(param).then((res) => {
            if (res.data.success) {
              that.$message.success('删除成功！');
              switch (typeLevel) {
                case 1:
                  that.getProduct_TypeList();
                  break;
                case 2:
                  that.getProduct_TypeList2(item.parentId);
                  break;
                case 3:
                  that.getProduct_TypeList3(item.parentId);
                  break;
                case 4:
                  that.getProduct_TypeList4(item.parentId);
                  break;
              }
            } else {
              that.$message.error(res.data.error.message)
            }
          })
        });
    },
    //编辑
    handleEdit(item, typeLevel) {
      let that = this;
      that.editFormVisible = true;
      that.editForm = Object.assign({}, item);
      switch (typeLevel) {
        case 1:
          that.dialogTit = "编辑一级分类";
          that.typeLevel = typeLevel;
          break;
        case 2:
          that.dialogTit = "编辑二级分类";
          that.typeLevel = typeLevel;
          break;
        case 3:
          that.dialogTit = "编辑三级分类";
          that.typeLevel = typeLevel;
          break;
        case 4:
          that.dialogTit = "编辑四级分类";
          that.typeLevel = typeLevel;
          break;
      }
    },
    editSubmit() {
      let that = this;
      var params = Object.assign({}, that.editForm);
      CategoryUpdate(params)
        .then((res) => {
          if (res.data.success) {
            // that.$message.error(res.data.error.message)
            that.editFormVisible = false;
            // that.editForm.PropertyGroupId = 0;
            switch (that.typeLevel) {
              case 1:
                that.getProduct_TypeList();
                break;
              case 2:
                that.getProduct_TypeList2(params.parentId);
                break;
              case 3:
                that.getProduct_TypeList3(params.parentId);
                break;
              case 4:
                that.getProduct_TypeList4(params.parentId);
                break;
            }
          } else {
            that.$message.error(res.data.error.message)
          }

        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //获取一级
    getProduct_TypeList() {
      let that = this;
      let params = {
        showAll: true,
        ParentId: 0,
      };
      CategoryGetAll(params)
        .then((res) => {
          that.typeList = res.data.result.items;
          if (res.data.result.items[0]) {
            that.activeId1 = res.data.result.items[0].id;
            setTimeout(() => {
              that.getProduct_TypeList2(res.data.result.items[0].id);
            }, 500);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //获取二级
    getProduct_TypeList2(parentId) {
      let that = this;
      let params = {
        showAll: true,
        ParentId: parentId,
      };
      that.activeId1 = parentId;
      that.typeList2 = [];
      that.typeList3 = [];
      that.typeList4 = [];
      CategoryGetAll(params)
        .then((res) => {
          that.typeList2 = res.data.result.items;
          if (res.data.result.items[0]) {
            that.activeId2 = res.data.result.items[0].id;
            setTimeout(() => {
              that.getProduct_TypeList3(res.data.result.items[0].id);
            }, 500);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //获取三级
    getProduct_TypeList3(parentId) {
      let that = this;
      let params = {
        showAll: true,
        ParentId: parentId,
      };
      that.activeId2 = parentId;
      that.typeList3 = [];
      that.typeList4 = [];
      CategoryGetAll(params)
        .then((res) => {
          that.typeList3 = res.data.result.items;
          if (res.data.result.items[0]) {
            that.activeId3 = res.data.result.items[0].id;
            setTimeout(() => {
              that.getProduct_TypeList4(res.data.result.items[0].id);
            }, 500);
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    //获取四级
    getProduct_TypeList4(parentId) {
      let that = this;
      let params = {
        showAll: true,
        ParentId: parentId,
      };
      that.activeId3 = parentId;
      that.typeList4 = [];
      CategoryGetAll(params)
        .then((res) => {
          that.typeList4 = res.data.result.items;
          if (res.data.result.items[0]) {
            that.activeId4 = res.data.result.items[0].id;
          }
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
  },
  mounted() {
    let that = this;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(that.$route.path, routers);
    buttonList.forEach((v) => {
      if (v.buttonFunc == "addProType") {
        that.isShowAdd = true;
      }
      if (v.buttonFunc == "handleEdit") {
        that.isShowEdit = true;
      }
      if (v.buttonFunc == "handleDel") {
        that.isShowDel = true;
      }
    });
    // const toolBarButtonList = buttonList.filter((item) => {
    //   return item.ButtonType === 10 && item.Func !== "handleAdd";
    // });
    // that.buttonList_toolBar = toolBarButtonList;

    // const tableButtonList = buttonList.filter((item) => {
    //   return item.ButtonType === 20;
    // });
    // that.buttonList_table = tableButtonList;
  },
};
</script>
<style scoped>
.main_wrap {
  width: 100%;
  height: 100%;
}

.toolbar_box {
  width: 100%;
  overflow: hidden;
}

.item_type_box {
  overflow: hidden;
  overflow-x: auto;
  width: 90%;
  height: 100%;
  margin-left: 20px;
  padding-bottom: 30px;
  display: flex;
  justify-content: flex-start;
}

.item_type_info {
  width: 25%;
  border-radius: 10px;
  height: calc(100vh - 240px);
  border: 1px solid #dcdfe6;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  overflow-x: auto;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style-type: none;
  color: #606266;
}

.tit {
  padding: 20px;
  font-weight: 600;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #303133;
}

.item_type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.item_type_l {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.item_type_r {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.el-icon-arrow-down {
  margin-left: 10px;
  transition: all 0.3s;
}

.rotate {
  transform: rotate(-90deg);
  transition: all 0.3s;
}

.active_icon {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.enabled {
  background: #e70200;
}

.no_enabled {
  background: #00c200;
}

.active_bg {
  background: #e4e7ed;
}

.no_type {
  text-align: center;
  color: #606266;
}
</style>
